/**
 * The one-click inline edit instructions offered in the selection popover.
 *
 * Shared with inline-edit analytics, which reports whether a submitted instruction came from a
 * preset by matching against these exact strings. Keeping one list
 * means a future preset change cannot silently reclassify submissions as free-form.
 */
export const kAgentV2InlineEditPresets = [
  { label: 'Polish writing', instruction: 'Improve the clarity, flow, and readability of this text while preserving the original meaning and tone.' },
  { label: 'Shorten', instruction: 'Shorten this text while preserving the key points.' },
  { label: 'Proofread', instruction: 'Fix any spelling, grammar, and punctuation errors in this text without changing the meaning or style.' },
] as const

export const kAgentV2InlineEditPresetInstructions: readonly string[] = kAgentV2InlineEditPresets.map((preset) => preset.instruction)
